export default {"src":"/_next/static/media/yardzen-logo-full.09f70c12.svg","height":20,"width":82,"blurWidth":0,"blurHeight":0};